import {
    LOAD_ALL_WORKERS,
    LOAD_ALL_ASSIGNMENTS_BY_PROJECT_ID,
    UPDATE_ASSIGNMENTS_BY_PROJECT_ID_AND_SET_WORKERS_THERE
  } from '../../actions/projectAssignment';
  
export default function projectAssignment(state = {}, action) {
    switch (action.type) {
        case LOAD_ALL_WORKERS:
            return Object.assign({}, state, action.payload);
        case LOAD_ALL_ASSIGNMENTS_BY_PROJECT_ID:
            return Object.assign({}, state, action.payload);
        case UPDATE_ASSIGNMENTS_BY_PROJECT_ID_AND_SET_WORKERS_THERE:
            return Object.assign({}, state, action.payload);               
        default:
            return state;   
    }
}
  


// WEBPACK FOOTER //
// ./src/reducers/projectAssignment/index.js